import { render, staticRenderFns } from "./AddNewTargetingRule.vue?vue&type=template&id=516db8b9&"
import script from "./AddNewTargetingRule.vue?vue&type=script&lang=js&"
export * from "./AddNewTargetingRule.vue?vue&type=script&lang=js&"
import style0 from "./AddNewTargetingRule.vue?vue&type=style&index=0&id=516db8b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports